var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "copy_1_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    fill: "#0071B9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.79,22.806h-44c-3.86,0-7,3.14-7,7v56c0,3.859,3.14,7,7,7h44c3.859,0,7-3.141,7-7v-56 C90.79,25.946,87.649,22.806,83.79,22.806z M82.79,84.806h-42v-54h42V84.806z M13.79,64.806h14.269v8H12.79c-3.86,0-7-3.141-7-7v-56 c0-3.86,3.14-7,7-7h44c3.859,0,7,3.14,7,7v8.625h-8v-7.625h-42V64.806z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.6c44093cf680e0e24e17f15de3e48e60.svg";
export { ForwardRef as ReactComponent };